import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import moment from "moment";

import {StateListAPI} from "./../../../../API/Admin/StateAPI";
import Sidebar from "./../../Common/Sidebar";
import Header from "./../../Common/Header";
import Loader from "./../../../Loader";
import Paginate from "./../../../../utils/Pagination";



const State = () =>{

    const [statelist, setStateList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pagecount, setPageCount] = useState(0);

    const perpagedata = 15;    


    useEffect(() => {

        //console.log('I am in state');

        StateListAPI(setStateList, setLoading, currentPage, perpagedata, setPageCount);

    }, [currentPage]);

    const handlePageClick = (data) =>{
        setCurrentPage(data.selected + 1);

    }
    
    return(
    <div className="main-wrapper">
        <Loader />

        <Header />

        <Sidebar />

        <div className="page-wrapper">
            <div className="content">

                <div className="row">
                    <div className="col-md-12">

                        <div className="page-header">
                            <div className="row align-items-center">
                                <div className="col-8">
                                    <h4 className="page-title">State List</h4>
                                </div>
                                <div className="col-4 text-end">
                                    <div className="head-icons">
                                        
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="card">

                            <div className="card-body">

                                <div className="d-flex align-items-center justify-content-between flex-wrap">
                                    <div className="dropdown">
                                        
                                    </div>
                                    <div className="d-flex align-items-center flex-wrap row-gap-2">
                                        
                                    </div>
                                </div>

                                <div className="table-responsive custom-table">
                                    
                                    <table className="table" id="faqlist">
                                        <thead className="thead-light">
                                            <tr>
                                                                                                
                                                <th>ID</th>
                                                <th>Name</th>
                                                <th>URL</th>
                                                <th>Status</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                    
                                        {loading ?
                                            <tr>
                                                <td colSpan="5">
                                                    <Loader />
                                                </td>
                                            </tr>
                                        :
                                            (statelist && statelist.length > 0  ? 
                                                ( statelist.map(state => 
                                                    (
                                            
                                                        <tr key={state.id}>
                                                            <td>{ state.id }</td>
                                                            <td>{state.name}</td>
                                                            <td>{state.state_url}</td>
                                                            <td>
                                                                { state.deleted_at == null ?
                                                                    <span className="badge badge-pill badge-status bg-success">Active</span>
                                                                :
                                                                    <span className="badge badge-pill badge-status bg-danger">Deactive</span>
                                                                }
                                                            </td>
                                                            <td>
                                                                <Link to="" className="btn btn-dark btn-sm me-2">
                                                                    <i className="ti ti-pencil"></i> Edit
                                                                </Link>
                                                                <button type="button" className="btn btn-danger btn-sm">
                                                                    <i className="ti ti-trash"></i> Delete
                                                                </button>													
                                                            </td>
                                                        </tr>
                                                    )
                                                ))
                                            
                                            :
                                        
                                                <tr>
                                                    <td colSpan="5">
                                                        <p>No record found...</p>
                                                    </td>
                                                </tr>
                                            )
                                        }
                                    
                                        </tbody>
                                    </table>
                                </div>

                                
                            </div>       
                        </div>

                        <div className="row pagination-section">
                            <nav>
                                <Paginate initialPage={perpagedata} pageCount={pagecount} onPageChange={handlePageClick} />
                            </nav>
                        </div>

                    </div>
                </div>

            </div>
        </div>

    </div>
    )
}

export default State;